<template>
  <div class="redirect-timer">
    <p class="header">You may have been looking for <a class="text-link" v-bind:href=url>{{url}}</a>.</p>
    <div id="redirect-timer-info" class="redirect-timer__info">
      <p class="paragraph">
        You will be automatically redirected in
        <span id="redirect-timer-digits" class="redirect-timer__digits">{{timeRemaining}}</span>
        seconds.
      </p>
      <binary-choice no-message="stop" yes-message="go now"></binary-choice>
    </div>
  </div>
</template>

<script>
  import BinaryChoice from './BinaryChoice';
  let timer;
  export default {
    components: {
      BinaryChoice,
    },
    props: {
      url: {
        type: String,
      },
      updatesPerSecond: {
        type: Number,
        default: 1,
      },
      timeRemaining: {
        type: Number,
        default: 30,
      },
    },
    methods: {
      startTimer() {
        clearInterval(timer);
        const startTime = window.performance.now() / 1000;
        const duration = this.timeRemaining;
        timer = setInterval(() => {
          this.timeRemaining = Math.ceil(startTime + duration - window.performance.now() / 1000);
          if (this.timeRemaining <= 0) {
            window.location = this.url;
          }
        }, 1000 / this.updatesPerSecond);
      },
      stopTimer() {
        clearInterval(timer);
        const redirectInfo = document.getElementById('redirect-timer-info');
        redirectInfo.parentNode.removeChild(redirectInfo);
      },
    },
    events: {
      choose(choice) {
        if (choice === true) {
          window.location = this.url;
          return;
        }
        if (choice === false) {
          this.stopTimer();
          return;
        }
        return;
      },
    },
    attached() {
      this.startTimer();
    },
  };
</script>

<style lang="scss">
  .redirect-timer {
    &__info {

    }
    &__digits {
      font-weight: bold;
    }
  }
</style>


/** WEBPACK FOOTER **
 ** RedirectTimer.vue?fff82e8e
 **/